import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import React from 'react'
import {useLocation} from 'react-router-dom'
import {branch, compose} from 'recompose'
import {ContentNotFound} from 'views/AppLocals/ContentNotFound'
import {bindQueryParams,} from 'views/AppLocals/functions/routerHelper'
import {catholicHousehold_getCatholicHouseholdStats_Api} from "../../../../apis/catholicHousehold";
import {staticPaths} from "../../../../routes/staticPaths";
import useAsync from "../../../../modules/asyncCache/useAsync";
import LoadingBlock from "../../../Loading/LoadingBlock";
import {CatholicHouseholdSvg} from "../../../../components/Svgs/CatholicHouseholdSvg";
import {IoCloseCircle, IoTimer} from "react-icons/io5";
import classNames from "classnames";
import {SacramentTypes} from "../../../AppLocals/CatholicHousehold/consts/SacramentTypes";
import {BaptismSacramentSvg} from "../../../../components/Svgs/BaptismSacramentSvg";
import {FirstCommunionSacramentSvg} from "../../../../components/Svgs/FirstCommunionSacramentSvg";
import {ConfirmationSacramentSvg} from "../../../../components/Svgs/ConfirmationSacramentSvg";
import {MatrimonySacramentSvg} from "../../../../components/Svgs/MatrimonySacramentSvg";
import {HolyOrdersSacramentSvg} from "../../../../components/Svgs/HolyOrdersSacramentSvg";
import {AnointingOfTheSickSacramentSvg} from "../../../../components/Svgs/AnointingOfTheSickSacramentSvg";
import {FiChevronsRight} from "react-icons/fi";


const getSacramentAppearance = (type, size = 30) => {
    let icon, background
    switch (type) {
        case 'baptism':
            icon = <BaptismSacramentSvg size={size} className="text-blue-600"/>;
            background = 'bg-blue-100';
            break
        case 'first_communion':
            icon = <FirstCommunionSacramentSvg size={size} className="text-yellow-600"/>;
            background = 'bg-yellow-50';
            break
        case 'confirmation':
            icon = <ConfirmationSacramentSvg size={size} className="text-primary-600"/>;
            background = 'bg-primary-50';
            break
        case 'matrimony':
            icon = <MatrimonySacramentSvg size={size} className="text-pink-600"/>;
            background = 'bg-pink-50';
            break
        case 'holy_orders':
            icon = <HolyOrdersSacramentSvg size={size} className="text-green-700"/>;
            background = 'bg-green-50';
            break
        case 'anointing_of_the_sick':
            icon = <AnointingOfTheSickSacramentSvg size={size} className="text-secondary-600"/>;
            background = 'bg-secondary-50';
            break
        default:
            break
    }
    return {icon, background}
}

const CatholicHouseholdStatistics = ({
                                         owner_id,
                                         owner_type,
                                     }) => {
    const t = useTranslate()
    const history = useHistory()
    const location = useLocation()
    const apiInfo = catholicHousehold_getCatholicHouseholdStats_Api;

    const {response, isLoading} = useAsync({
        cacheId: [
            apiInfo.path
                .replace(':type', owner_type)
                .replace(':id', owner_id),
            JSON.stringify({}),
        ].join('/'),
        apiInfo,
        values: {},
        // deps: [{}],
        query: bindQueryParams([{type: owner_type}, {id: owner_id}]),
    })

    const item = _.get(response, 'data', {})

    const {by_sacrament_type = [], total, sacrament_year} = item ?? {}

    if (isLoading) {
        return (
            <LoadingBlock/>
        )
    }

    return (
        <div className="flex flex-col gap-3">
            <div className="flex flex-col flex-1">
                <h2 className="font-bold text-xl text-gray-800 tracking-wide">
                    {t('catholic household')}
                </h2>
                <div className="my-1 w-20 h-1 rounded-full bg-gray-400"/>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                {[
                    {
                        icon: <CatholicHouseholdSvg size={22} className="text-secondary-200 opacity-80"/>,
                        label: 'having',
                        value: total?.households,
                        href: '/households?rel=catholic-households',
                        border: 'border-t-3 border-blue-500',
                    },
                    {
                        icon: <IoTimer size={22} className="text-secondary-200 opacity-80"/>,
                        label: 'pending',
                        value: total?.pending,
                        href: '/households?rel=pending-catholic-households',
                        border: 'border-t-3 border-orange-500',
                    },
                    {
                        icon: <IoCloseCircle size={22} className="text-secondary-200 opacity-80"/>,
                        label: 'reject',
                        value: total?.rejected,
                        href: '/households?rel=catholic-households&status=-2',
                        border: 'border-t-3 border-secondary-500',
                    },
                ].map((e, i) => (
                    <div
                        onClick={() => (
                            history.push(staticPaths.workspace.pathname + e?.href)
                        )}
                        className={classNames('px-4 py-3 flex flex-col background shadow-lg rounded-xl relative', e?.border)}>
                        <span className="text-xs text-gray-400 uppercase tracking-wider">
                            {t(e?.label)}
                        </span>
                        <span className="text-2xl font-bold uppercase">
                            {e?.value}
                        </span>
                        <div style={{top: '50%', transform: 'translate(0, -50%)'}} className="absolute right-12">
                            {e?.icon}
                        </div>
                    </div>
                ))}
            </div>

            <div className="mt-6 flex flex-col background shadow-md rounded-xl">
                <div className="px-3 py-2 background-200 rounded-t-xl flex items-center gap-3">
                    <span className="flex-1 font-medium text-sm text-gray-700 tracking-wide">
                        {t('lookup by sacrament')} ({t('years')} {sacrament_year})
                    </span>
                </div>
                <div className="p-4 grid grid-cols-1 md:grid-cols-2 gap-4">
                    {by_sacrament_type?.map((e,i) => {
                        const {icon, background} = getSacramentAppearance(e?.sacrament_type, 40)
                        return (
                            <div
                                key={i}
                                style={{
                                    padding: '0.75rem', transition: 'all 0.3s', cursor: 'pointer',
                                    display: 'flex', flexDirection: 'column', borderRadius: '0.75rem',
                                }}
                                className="border border-color-100 hover:border-secondary-500 hover:shadow-lg hover:scale-101 text-color-000 hover:text-secondary-600 transition-all duration-300">
                                <div className="flex items-center gap-2">
                                    <div className={classNames('p-2 flex flex-center rounded-xl', background)}>
                                        {icon}
                                    </div>
                                    <div className="flex flex-col flex-1">
                                        <span
                                            onClick={() => (
                                                history.push(staticPaths.workspace.pathname + '/households?rel=catholic-household-query-' + e?.sacrament_type)
                                            )}
                                            className="font-bold text-base tracking-wide">
                                            {t(_.find(SacramentTypes, {value: e?.sacrament_type})?.label)}
                                        </span>
                                        <span className="text-xs text-color-300 tracking-wider">
                                            {t(_.find(SacramentTypes, {value: e?.sacrament_type})?.description)}
                                        </span>
                                    </div>
                                </div>
                                <div className="my-2 border-b border-color-50"/>
                                <div className="flex items-center gap-3">
                                    {e?.count > 0 ? (
                                        <span className="flex-1 text-color-400 tracking-wider">
                                            <span className="mr-1 font-semibold text-secondary-600">
                                                {e?.count}
                                            </span>
                                            {t('current year').toLowerCase()}
                                        </span>
                                    ) : (
                                        <div className="flex-1"/>
                                    )}
                                    <span
                                        onClick={() => (
                                            history.push(staticPaths.workspace.pathname + '/households?rel=catholic-household-query-' + e?.sacrament_type)
                                        )}
                                        className="flex items-center gap-1 text-xs text-color-300 hover:text-secondary-600 italic cursor-pointer contextIcon">
                                        {t('view detail')} <FiChevronsRight size={11}/>
                                    </span>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}


export default compose(
    branch(
        ({owner_id, owner_type}) => _.some([owner_id, owner_type], _.isEmpty),
        () => () => <ContentNotFound/>
    )
)(CatholicHouseholdStatistics)
